import { Localized } from "@fluent/react";
import { Box } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded"


export const CapsLockWarning = () => (
    <Box
        component="span"
        sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.75,
            color: "warning.main",
            fontWeight: 700,
        }}
    >
        <WarningAmberRoundedIcon sx={{ fontSize: 18 }} />
        <Localized id="authorization-capslock-warning"><span>_Caps Lock jest włączony</span></Localized>
    </Box>
)
